import { create } from 'zustand';

interface LoggedOutDialogState {
    isOpen: boolean;
    openDialog: () => void;
    closeDialog: () => void;
}

export const useLoggedOutDialogStore = create<LoggedOutDialogState>((set) => ({
    isOpen: false,
    openDialog: () => set({ isOpen: true }),
    closeDialog: () => set({ isOpen: false }),
}));